import { styled, alpha } from "@mui/material/styles";
import {
  AppBar,
  Toolbar,
  InputBase,
  IconButton,
  Menu,
  Box,
  Typography,
  Button,
  Badge,
} from "@mui/material";

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.sidebar.primary,
  boxShadow: "none",
  borderBottom: `1px solid ${alpha(theme.palette.common.white, 0.08)}`,
  position: "fixed",
  width: "100%",
  zIndex: 1201,
  transition: "all 0.3s ease",
  height: "48px",
}));

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  height: "48px",
  minHeight: "48px !important",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0, 2),
  transition: "all 0.3s ease",
  color: theme.sidebar.text.primary,
  gap: "24px",
}));

export const LogoContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  minWidth: "200px",
  height: "48px",
  padding: "0 0px",
  "& .logo-wrapper": {
    height: "100%",
    display: "flex",
    alignItems: "center",
    gap: "30px",
    marginLeft:"-10px"
  },
  "& img": {
    height: "50%",
    width: "auto",
    objectFit: "contain",
    // padding: "2px 0",
  },
}));

export const SearchContainer = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "6px",
  backgroundColor: alpha(theme.palette.common.white, 0.04),
  border: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.06),
    border: `1px solid ${alpha(theme.palette.common.white, 0.15)}`,
  },
  marginRight: theme.spacing(2),
  marginLeft: theme.spacing(2),
  width: "100%",
  maxWidth: "400px",
  height: "32px",
  transition: "all 0.2s ease",
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 1.2),
  height: "32px",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: alpha(theme.palette.common.white, 0.6),
  "& svg": {
    fontSize: "18px",
  },
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: theme.palette.common.white,
  width: "100%",
  height: "32px",
  display: "flex",
  alignItems: "center",

  "& .MuiInputBase-input": {
    padding: "0 12px 0 40px",
    height: "32px",
    lineHeight: "32px",
    fontSize: "13px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    transition: theme.transitions.create("width"),
    "&::placeholder": {
      color: alpha(theme.palette.common.white, 0.5),
      opacity: 1,
      lineHeight: "32px",
    },
  },
}));

export const BrandText = styled("h1")(({ theme }) => ({
  margin: 0,
  fontSize: "14px",
  fontWeight: 600,
  color: theme.sidebar.text.primary,
  letterSpacing: "1.2px",
  fontFamily: "'Inter', sans-serif",
  opacity: 0.95,
  userSelect: "none",
}));

export const ActionButtons = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginRight: "8px",
  position: "relative",
  // "&:before": {
  //   content: '""',
  //   position: "absolute",
  //   left: -16,
  //   top: "50%",
  //   transform: "translateY(-50%)",
  //   height: "24px",
  //   width: "1px",
  //   backgroundColor: alpha(theme.palette.common.white, 0.08),
  // },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: "32px",
  height: "32px",
  padding: "4px",
  borderRadius: "8px",
  backgroundColor: theme.sidebar.hover,
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: theme.sidebar.active,
  },
  "& .MuiAvatar-root": {
    width: "24px",
    height: "24px",
    border: `1px solid ${alpha(theme.palette.common.white, 0.12)}`,
  },
}));

export const TopbarIconButton = styled(IconButton)(({ theme }) => ({
  width: "32px",
  height: "32px",
  borderRadius: "8px",
  color: theme.sidebar.text.secondary,
  backgroundColor: "transparent",
  padding: "6px",
  "&:hover": {
    backgroundColor: theme.sidebar.hover,
    color: theme.sidebar.text.primary,
  },
  "& svg": {
    fontSize: "20px",
  },
  transition: "all 0.2s ease",
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: "8px",
    minWidth: 280,
    maxWidth: 280,
    maxHeight: "300px !important",
    overflow: "hidden",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    "& .MuiMenu-list": {
      padding: 0,
    },
  },
}));

export const MenuHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  borderBottom: "1px solid #edf2f7",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#fff",
  position: "sticky",
  top: 0,
  zIndex: 1,
}));

export const MenuTitle = styled(Typography)(({ theme }) => ({
  fontSize: "0.75rem",
  fontWeight: 600,
  color: theme.palette.grey[800],
}));

export const NotificationList = styled(Box)(({ theme }) => ({
  maxHeight: "200px",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "3px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.grey[300],
    borderRadius: "4px",
  },
}));

export const NotificationListItem = styled(Box)(({ theme, isUnread }) => ({
  padding: theme.spacing(1),
  borderBottom: "1px solid #edf2f7",
  backgroundColor: "transparent",
  cursor: "pointer",
  transition: "all 0.15s ease",
  position: "relative",
  display: "flex",
  alignItems: "flex-start",
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
  },
  "&:last-child": {
    borderBottom: "none",
  },
}));

export const NotificationMessage = styled(Typography)`
  font-size: 12px;
  color: #333;
  margin-bottom: 4px;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 2.6em;
  transition: max-height 0.3s ease;
  font-weight: 400;
  letter-spacing: 0.01em;
`;

export const ReadMoreButton = styled(Button)`
  font-size: 11px !important;
  padding: 0 !important;
  min-width: auto !important;
  color: ${({ theme }) => theme.palette.primary.main} !important;
  text-transform: none !important;
  margin-top: 2px !important;
  font-weight: 500 !important;
  &:hover {
    background: none !important;
    text-decoration: underline;
    color: ${({ theme }) => theme.palette.primary.dark} !important;
  }
`;

export const NotificationTime = styled(Typography)(({ theme }) => ({
  fontSize: "0.65rem",
  color: theme.palette.grey[600],
  display: "flex",
  alignItems: "center",
  gap: "3px",
  "& .MuiSvgIcon-root": {
    fontSize: "11px",
    color: theme.palette.grey[500],
  },
}));

export const NotificationLink = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "3px",
  fontSize: "0.65rem",
  color: theme.palette.primary.main,
  fontWeight: 500,
  padding: "2px 6px",
  borderRadius: "4px",
  transition: "all 0.15s ease",
  "& .MuiSvgIcon-root": {
    fontSize: "12px",
  },
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    color: theme.palette.primary.dark,
  },
}));

export const NotificationBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    fontWeight: "bold",
    fontSize: "0.65rem",
    minWidth: "18px",
    height: "18px",
    borderRadius: "9px",
    padding: "0 4px",
    right: -3,
    top: 3,
    border: `2px solid ${theme.sidebar.primary}`,
    animation: "pulse 2s infinite",
    "@keyframes pulse": {
      "0%": {
        boxShadow: `0 0 0 0 ${alpha(theme.palette.error.main, 0.4)}`,
      },
      "70%": {
        boxShadow: `0 0 0 6px ${alpha(theme.palette.error.main, 0)}`,
      },
      "100%": {
        boxShadow: `0 0 0 0 ${alpha(theme.palette.error.main, 0)}`,
      },
    },
  },
}));
